// extracted by mini-css-extract-plugin
export default {"ace-c-invoice-submissions-screen__loader":"invoice-submissions-screen__loader---66dd0530"};